// extracted by mini-css-extract-plugin
module.exports = {"OrDivider":"OrDivider_OrDivider__1O9oW","Vertical":"OrDivider_Vertical__1SikQ"};